const RATIOS = {
  "21:9": "aspect-[21/9]",
  "16:9": "aspect-[16/9]",
  "3:2": "aspect-[3/2]",
  "4:3": "aspect-[4/3]",
  "1:1": "aspect-square",
};

/** Resolve a photo filename to its public path. */
export const imgSrc = (filename) => `/images/${filename}`;

/** If a photo fails to load, hide it so the neutral container shows instead of a broken-image icon. */
export const hideOnError = (e) => {
  e.currentTarget.style.visibility = "hidden";
  e.currentTarget.setAttribute("data-image-failed", "true");
};

/**
 * Photo slot. `label` is the image filename (also the slot ID). The photo is
 * resolved from /images/<label> unless an explicit `src` is given.
 */
export const ImageSlot = ({
  label,
  note: _note,
  ratio = "3:2",
  src,
  alt,
  priority = false,
  fill = false,
  dark = false,
  className = "",
  imgClassName = "",
  ...rest
}) => {
  const ratioCls = fill ? "absolute inset-0" : RATIOS[ratio] || RATIOS["3:2"];
  return (
    <div
      data-slot={label}
      data-testid={`image-slot-${label}`}
      className={`relative overflow-hidden ${dark ? "bg-navy" : "bg-alt"} ${ratioCls} ${className}`}
      {...rest}
    >
      <img
        src={src || imgSrc(label)}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        decoding="async"
        draggable={false}
        onError={hideOnError}
        className={`absolute inset-0 h-full w-full object-cover ${imgClassName}`}
      />
    </div>
  );
};
